import { createContractDataAccessor } from './createContractDataLocator';
function evaluateEqualityRule(contractDataSources, _ref) {
  var property = _ref.property,
    operator = _ref.operator,
    value = _ref.value;
  var getContractDataValue = createContractDataAccessor(contractDataSources);
  var propertyValue = getContractDataValue(property);
  switch (operator) {
    case 'eq':
      // eslint-disable-next-line eqeqeq
      return propertyValue == value;
    case 'ne':
      // eslint-disable-next-line eqeqeq
      return propertyValue != value;
    case 'gt':
      return value !== null && propertyValue > value;
    case 'lt':
      return value !== null && propertyValue < value;
    case 'lte':
      return value !== null && propertyValue <= value;
    case 'gte':
      return value !== null && propertyValue >= value;
    case 'includes':
      if (typeof propertyValue === 'string' && typeof value === 'string') {
        return propertyValue.includes(value);
      }
      if (Array.isArray(propertyValue)) {
        return propertyValue.includes(value);
      }
      return false;
    default:
      return false;
  }
}
function evaluateLogicRule(parameterSources, _ref2) {
  var operator = _ref2.operator,
    expressions = _ref2.expressions;
  switch (operator) {
    case 'and':
      return expressions.every(function (x) {
        return evaluateCondition(parameterSources, x);
      });
    case 'or':
      return expressions.findIndex(function (x) {
        return evaluateCondition(parameterSources, x);
      }) !== -1;
    default:
      return false;
  }
}
export function evaluateCondition(parameterSources, rule) {
  if (isLogicRule(rule)) {
    return evaluateLogicRule(parameterSources, rule);
  }
  return evaluateEqualityRule(parameterSources, rule);
}
function isLogicRule(rule) {
  return rule.operator === 'or' || rule.operator === 'and';
}